<template>
  <div id="app">
    <!-- <h1>Hello App!</h1>
    <p>
      <router-link to="/t">Go to 页面</router-link>
      <router-link to="/t1"> Go to 页面1</router-link>
    </p> -->
    <!-- <router-view /> -->

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <!-- <keep-alive>
      <router-view />
    </keep-alive> -->
  </div>
</template>

<script>
import commonData from '@/commondata.js'
import store from '@/store'
export default {
  name: 'App',
  components: {
  },
  created() {
    if (commonData.ssiBase === undefined) {
      store.dispatch('user/getSSIBaseData')
    }
    if (commonData.enumList === undefined) {
      store.dispatch('user/getEnumList')
    }
  },
  methods: {
  }
}
</script>

<style>
#app {
  font-family: PingFangSC-Regular, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center;
  color: #2c3e50;
  margin-top: 60px;  */
}
</style>
